function UpdateAccessRight(userId, businessId, srvId, rightId, premisesId, isGrantedAccess, roleName, actionurl) {
    var jsonData = JSON.stringify({ userId: userId, businessId: businessId, serviceId: srvId, rightId: rightId, isGranted: isGrantedAccess, premisesId: premisesId });
    console.log(actionurl);
    $.ajax({
        method: "POST",
        url: actionurl,
        data: jsonData,
        dataType: "json",
        traditional: true,
        contentType: "application/json; charset=utf-8"
    })
     .done(function (msg) {
         if (msg == true) {
             $('#statusMessage').hide();
             //uncheck the related checkboxes
             var checkBoxName = srvId.toString() + '-' + rightId.toString();
             var isAdmin = roleName == 'Admin';


             if (isAdmin && isGrantedAccess) {
                 $("[name^=" + srvId.toString() + "-]").each(function (index, value) {
                     if (index > 0) {
                         $(this).attr('checked', false);
                     }

                 });
             }
             else if (isGrantedAccess) {
                 $("[name^=" + srvId.toString() + "-]").each(function (index, value) {
                     if (index == 0) {
                         $(this).attr('checked', false);
                     }

                 });

             }

         }
         else {
             //show error message

             $('#statusMessage').show();
         }

     });
}

var acknowledgeInvitation = function(userId, businessId) {
    var jsonData = JSON.stringify({ userId: userId, businessId: businessId });
    console.log(jsonData);
    $.ajax({
        method: "POST",
        url: '/Ajax/AcknowledgeInvitation',
        data: jsonData,
        dataType: "json",
        traditional: true,
        contentType: "application/json; charset=utf-8"
    }).done(function(msg) {
        if (msg === true) {
           
        }
    });
}